import { memo, useEffect, useRef, useState } from 'react';
import placeholderImage from "../../../../assets/images/menu/540x360.png";

interface ItemImageProps {
    item: {
        photoThumbnails?: string[];
    };
}

const ItemImage: React.FC<ItemImageProps> = ({ item }) => {
    // Use ref to track if the component is mounted
    const isMounted = useRef(true);

    // State for the current image source
    const [finalSrc, setFinalSrc] = useState(placeholderImage);
    const [isLoading, setIsLoading] = useState(false);

    // Preload the image to check validity
    useEffect(() => {
        const thumbSrc = Array.isArray(item?.photoThumbnails) &&
            item.photoThumbnails.length > 0 ?
            item.photoThumbnails[0] :
            null;

        // If no thumbnail, just use placeholder
        if (!thumbSrc) {
            setFinalSrc(placeholderImage);
            setIsLoading(false);
            return;
        }

        setIsLoading(true);

        // Try to preload the image
        const img = new Image();
        img.onload = () => {
            if (isMounted.current) {
                setFinalSrc(thumbSrc);
                setIsLoading(false);
            }
        };
        img.onerror = () => {
            if (isMounted.current) {
                setFinalSrc(placeholderImage);
                setIsLoading(false);
            }
        };

        // Start loading
        img.src = thumbSrc;
    }, [item?.photoThumbnails]);

    // Effect for cleanup when component unmounts
    useEffect(() => {
        isMounted.current = true;
        return () => {
            isMounted.current = false;
        };
    }, []);

    return (
        <img
            src={finalSrc}
            alt="menu item"
            loading="lazy"
            decoding="async"
            className={`img-fluid transition opacity-0 ${isLoading ? '' : 'opacity-100'}`}
            // className={`img-fluid transition opacity-0 ${isLoading ? '' : 'opacity-100'}`}
            // style={{ transition: 'opacity 0.5s ease-in-out' }}
        />
    );
};

export default memo(ItemImage, (prevProps, nextProps) => {
    return JSON.stringify(prevProps.item?.photoThumbnails) === JSON.stringify(nextProps.item?.photoThumbnails);
});